import { ChangeDetectorRef, Component, Input} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyContractModel, ContractStepModel, PaymentTransactionModel_Opt } from '../../../../models/contract.model';
import { IMultiPaymentCS, IMultiPaymentStateCS } from '../../../../models/finance.model';
import { Subscription } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { ContractDataService } from '../../services/contract-data.service';
import { ContractStepNameService } from '../../services/contract-step-name.service';

interface IPartyData {
  name:string,
  guid:string,
  subtype:string
}
@Component({
    selector: 'app-contract-step-payment-edit',
    templateUrl: './contract-step-payment-edit.component.html',
    styleUrl: './contract-step-payment-edit.component.scss',
 
})
export class AppcontractStepPaymentEditComponent {
    private subs = new Subscription()
    @Input() contractStep!: ContractStepModel
    @Input() contractParties!: CompanyContractModel[]
    public editPaymentForm: FormGroup;
    public fullParties:IPartyData[] = []
    public toParties:IPartyData[] = []
    public fromParties:IPartyData[] = []
    public paymentGuid:string=''
    public paymentCreate:boolean = false
    constructor(
      private fb: FormBuilder,
      private dialogRef:MatDialogRef<AppcontractStepPaymentEditComponent>,
      private contractDataService:ContractDataService,
      private contractStepNameService:ContractStepNameService
    ) { 
      this.editPaymentForm = fb.group({
          payer_guid: [null],
          //payer_guid: [null, {validators: [Validators.required]}],
          payer_type: [null],
          recipient_guid: [null],
          recipient_type: [null],
          total: [null, {validators: [Validators.pattern('[0-9,]*([0-9.]{0,3})?$') ]}],
      });
    }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.paymentGuid = this.contractStep.payment_data?.payment_guid||''
      this.contractStep.payment_data? this.editPaymentForm.patchValue(this.contractStep.payment_data) : null
      this.fullParties = this.contractParties.map(el=>{
        return {
          name:el.project.name,
          guid:el.project.guid,
          subtype:el.project.subtype==='MEMBER'? 'MEMBER' : 'PROJECT' }
      }) 
      this.toParties = this.fullParties
      this.fromParties = this.fullParties
      this.subs.add(
        this.payer_guid?.valueChanges.subscribe(val=>{        
          if (val && val===this.recipient_guid?.value) {
            this.recipient_guid?.patchValue(null);
            this.recipient_type?.patchValue(null);
          }}))
      this.subs.add(
        this.recipient_guid?.valueChanges.subscribe(val=>{
          if (val && val===this.payer_guid?.value) {
            this.payer_guid?.patchValue(null);
            this.payer_type?.patchValue(null);
          }
        }))
    }
    cancelAction() {
      this.dialogRef.close()
    }
    addPaymentToStep() {
      this.recipient_type?.patchValue(this.fullParties.find(el=>el.guid===this.recipient_guid?.value)?.subtype)
      this.payer_type?.patchValue(this.fullParties.find(el=>el.guid===this.payer_guid?.value)?.subtype)
      this.contractStep.payment_data = this.editPaymentForm.value
      this.contractStep.payment_data && !this.total?.value ? this.contractStep.payment_data.total = 0 : null;
      
      this.contractStep.payment_data!.payment_guid = this.paymentGuid
      switch (this.contractStep.target_type) {
        case 'payment':
        case 'direct_payment':
          let payment = this.contractDataService.getCachedStepTargetData(this.contractStep) as PaymentTransactionModel_Opt;
          payment && this.contractStep.payment_data? payment  =  this.contractStep.payment_data : null;
        break;
        case 'multi_payment':
          this.handleMultiPayment()
        break;
      }
      this.contractDataService.subContractEdited.next(true)
      this.contractDataService.subContractDetectChanges.next(true)
          let newStepName = this.contractStepNameService.stepNameGenerator(this.contractStep)
          this.contractDataService.subStepDataChanged.next({
              stepName: newStepName?.stepName||'',
              step: this.contractStep
          });
      this.dialogRef.close()
    }
    handleMultiPayment () {
      if (this.paymentCreate === false) {
        let editedIndex = this.contractStep.multi_payment_data!.findIndex(el=>el.payment_guid === this.paymentGuid )
        this.contractStep.multi_payment_data![editedIndex] = this.editPaymentForm.value
        let targetData = this.contractDataService.getCachedStepTargetData(this.contractStep) as IMultiPaymentStateCS 
        let payment = targetData.paymentsData.find(el=>el.payment.guid === this.paymentGuid)  as IMultiPaymentCS; 
        Object.entries(this.contractStep.payment_data!).forEach(el=>(payment.payment as any)[el[0]] = el[1] )
        this.contractStepNameService.stepNameGenerator(this.contractStep)
      } else {
        let multiPayments = this.contractDataService.getCachedStepTargetData(this.contractStep) as IMultiPaymentStateCS 
        if (!multiPayments) {
          multiPayments= {
            paymentsData : [],
            signedPayment: '',
            isMemberSign: false,
            isSignPaymentsALot: false,
          };
        }
        multiPayments.paymentsData.push({
          members:[],
          isCurrentMemberSign:false,
          payment: {
            ...this.editPaymentForm.value,
            guid:this.paymentGuid
          }
          
        })
        this.contractDataService.setStepTargetData(this.contractStep,multiPayments)
        this.contractStep.multi_payment_data?.push(this.editPaymentForm.value)
      }
    }
    get payer_guid() {return this.editPaymentForm.get('payer_guid')}
    get payer_type() {return this.editPaymentForm.get('payer_type')}
    get recipient_guid() {return this.editPaymentForm.get('recipient_guid') }
    get recipient_type() {return this.editPaymentForm.get('recipient_type') }
    get total() {return this.editPaymentForm.get('total')  }
}